module.exports = __webpack_public_path__ + "static/media/no-items-found.60df6698.png";